import { gql } from '@apollo/client';

export const QUERY_INVOICE_FILTERS = gql`
    query messagesFilters{
        getAllMessagesFilters{
            company {
                text
                value
            }
            process {
                text
                value
            }
            m_interface {
                text
                value
            }
            status {
                text
                value
            }
            step_number {
                text
                value
            }
            step {
                text
                value
            }
            duplicate {
                text
                value
            }
            sys_id {
                text
                value
            }
            group_name {
                text
                value
            }
            m_format {
                text
                value
            }
        }
    }
    
`;

export const QUERY_INVOICE_STATUS = gql`
    query GET_InvoicesStatuses($env: String!,$request: EIMMonitoringGridRequest!) {
          getEIMInvoices(env:$env,request: $request) {
            invoiceStatusesList {
                id
                message_id
                partnerno
                company
                reference
                bmw_int_reference
                duplicate
                cross_border
                process
                m_interface
                step_number
                step
                status
                status_reason
                creation_ts
                sdi_number
                invoice_date
                log_obj_id
                log_status_id
                edi_agreement_date
                sys_id
                ebox_folder
                m_format
                vin_number
                process_code
                route_id
                group_name
                log_info_id
                incident_no
                ext_reference
                channel
                target_directory
                insert_user
                update_user
                insert_ts
                original_log_obj_id
                system_id
                partner_country
                partner_name
                document_available
                uuid
                file_name
                id_partner
                clearing_house
                shippartnerno
                edp_relevant
                updatetime
                m_process
                final_completion
                c_status
                m_provider
                received_date
                complete_date
                m_invprocess
                md_process_id
                process_error
                apar
                document_type
                gross_amount
                tax_amount
                currency
            }
            total
        }
    }


`;

export const MUTATION_UPDATE_INVOICE_STATUS = gql`
    mutation UpdateInvoiceStatuses($env: String!, $request: EIMStatusUpdateRequest!) {
        updateEIMInvoiceStatuses(env: $env, request: $request) {
            updatedRows
        }
    }
`;